exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.range-container[data-v-4929a9bd] {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    font-family: sans-serif;\n}\ninput[type=\"range\"][data-v-4929a9bd] {\n    width: 200px;\n}\n", ""]);

// exports
